export const SHEETS_URL =
  "https://docs.google.com/spreadsheets/d/e/2PACX-1vR_-5Gt7fsmpyM3M9m315bFUFv7jkt9c3Tu6Qg7xzCbVeGJlUlKjLsKTLOBxNFRh9EWsD0aRH79hUCw/pub?gid=1902887224&single=true&output=csv";
